module.exports = __webpack_public_path__ + "img/download.eb793fb1.png";